export default __webpack_public_path__ + "media/61e4ca0cd6ee668707fcef0e21eb9132431d1a2fadb546bcb06900404e906481.svg";